var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUniversityGeneralResearchoutput(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 42.742,
    height: 42.283,
    viewBox: "0 0 42.742 42.283",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "data-analytics",
    transform: "translate(-1.349 -2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55218",
    "data-name": "Path 55218",
    d: "M28.5,44h4.933v4.933H28.5Z",
    transform: "translate(-8.017 -12.402)",
    fill: "#63c5b7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3380",
    "data-name": "Rectangle 3380",
    width: 8.457,
    height: 9.161,
    rx: 1,
    transform: "translate(18.721 35.122)",
    fill: "#387f75"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2810",
    "data-name": "Ellipse 2810",
    cx: 14.799,
    cy: 14.799,
    r: 14.799,
    transform: "translate(8.15 3.409)",
    fill: "#387f75"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2811",
    "data-name": "Ellipse 2811",
    cx: 11.98,
    cy: 11.98,
    r: 11.98,
    transform: "translate(10.969 6.228)",
    fill: "#dff9ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55219",
    "data-name": "Path 55219",
    d: "M2.266,48.468,1.349,47.4,6.282,43.17a.706.706,0,0,1,.957.037L9.612,45.58l3.031-2.425.88,1.1L10,47.074a.705.705,0,0,1-.938-.052L6.7,44.665Z",
    transform: "translate(0 -12.107)",
    fill: "#387f75"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55220",
    "data-name": "Path 55220",
    d: "M58.846,2l-5.638.939,1.805,1.805L51.32,8.171,52.278,9.2l3.733-3.462,1.9,1.9Z",
    transform: "translate(-14.756)",
    fill: "#387f75"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3381",
    "data-name": "Rectangle 3381",
    width: 12.685,
    height: 4.228,
    rx: 2,
    transform: "translate(16.607 11.866)",
    fill: "#aee0d9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3382",
    "data-name": "Rectangle 3382",
    width: 12.685,
    height: 4.228,
    rx: 2,
    transform: "translate(16.607 16.094)",
    fill: "#63c5b7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3383",
    "data-name": "Rectangle 3383",
    width: 12.685,
    height: 4.228,
    rx: 2,
    transform: "translate(16.607 20.323)",
    fill: "#387f75"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_48094",
    "data-name": "Group 48094",
    transform: "translate(18.016 13.275)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55221",
    "data-name": "Path 55221",
    d: "M25,18h1.409v1.409H25Z",
    transform: "translate(-25 -18)",
    fill: "#dff9ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55222",
    "data-name": "Path 55222",
    d: "M31,18.25h5.638v1.057H31Z",
    transform: "translate(-26.772 -18.074)",
    fill: "#dff9ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55223",
    "data-name": "Path 55223",
    d: "M25,24h1.409v1.409H25Z",
    transform: "translate(-25 -19.772)",
    fill: "#dff9ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55224",
    "data-name": "Path 55224",
    d: "M31,24.25h5.638v1.057H31Z",
    transform: "translate(-26.772 -19.846)",
    fill: "#dff9ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55225",
    "data-name": "Path 55225",
    d: "M25,30h1.409v1.409H25Z",
    transform: "translate(-25 -21.543)",
    fill: "#dff9ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55226",
    "data-name": "Path 55226",
    d: "M31,30.25h5.638v1.057H31Z",
    transform: "translate(-26.772 -21.617)",
    fill: "#dff9ff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUniversityGeneralResearchoutput);
export default __webpack_public_path__ + "static/media/university-general-researchoutput.fa0083e079032c372d826d8a7b4d94fb.svg";
export { ForwardRef as ReactComponent };